/**
 * 子路径挂载前缀（与 next.config.ts 的 basePath 同源）。
 *
 * Next 的 basePath 只自动作用于框架自己产出的东西：页面路由、`next/link`、
 * `/_next/*` 静态资源、RSC 请求。**手写的 fetch("/api/...") 不受影响** ——
 * 它们仍会打到 origin 根，在子路径挂载下必然走错。所以站内请求一律经过
 * {@link withBasePath} 再发。
 *
 * ⚠️ 这里的硬编码兜底必须与 next.config.ts 里的 BASE_PATH 一致。
 * 不靠 `NEXT_PUBLIC_BASE_PATH` 单打独斗的原因：该变量在 next.config 求值时拿不到
 * （见那边注释），同一个坑不该踩两次。
 */
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH || "/plugins/dsh-image-gen/aicomic";

/**
 * 给站内绝对路径补上 basePath；非站内路径（完整 URL、相对路径）原样返回。
 */
export function withBasePath(url: string): string {
  if (BASE_PATH === "" || !url.startsWith("/")) return url;
  return `${BASE_PATH}${url}`;
}
